// extracted by mini-css-extract-plugin
module.exports = {"Label":"Select_Label__SBLSK","SelectInput":"Select_SelectInput__2Wcrq"};